<template>
  <div id="speakers">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item">
            <a href="javascript:;" class="navbar-nav-link" @click="isFilterEnabled = !isFilterEnabled">
              {{ this.$t('event.components.participants.navbar.filterRecord') }}
              <i
                class="fas fa-search ml-1"
                :class="
                  ($store.state.programrate.filter.searchTerm != null && $store.state.programrate.filter.searchTerm != '') ||
                  ($store.state.programrate.filter.participantNO != null && $store.state.programrate.filter.participantNO != '') ||
                  ($store.state.programrate.filter.status != null && $store.state.programrate.filter.status != '') ||
                  ($store.state.programrate.filter.speakerID != null && $store.state.programrate.filter.speakerID != '') ||
                  ($store.state.programrate.filter.programID != null && $store.state.programrate.filter.programID != '')
                    ? 'animate__animated animate__pulse animate__infinite text-info'
                    : ''
                "
              ></i>
            </a>
          </li>
        </ul>
      </portal>
      <div class="content animated fadeIn">
        <transition name="slide-fade">
          <div class="filter-card card card-collapsed" :style="isFilterEnabled ? 'display:block;' : 'display:none;'">
            <div class="card-header header-elements-inline">
              <h5 class="card-title">{{ this.$t('event.components.participants.navbar.filterRecord') }}</h5>

              <div class="header-elements">
                <div class="list-icons">
                  <el-button-group>
                    <el-button
                      size="mini"
                      @click="
                        $store.state.programrate.filter.searchTerm = null;
                        $store.state.programrate.filter.participantNO = null;
                        $store.state.programrate.filter.speakerID = null;
                        $store.state.programrate.filter.programID = null;
                        $store.state.programrate.filter.status = null;
                        $refs.SpeakerSelect.resetFilter();
                        $refs.ProgramSelect.resetFilter();
                      "
                      round
                      >{{ $t('event.buttons.reset') }}</el-button
                    >
                    <el-button size="mini" type="danger" @click="isFilterEnabled = false" round>{{ $t('event.buttons.close') }}</el-button>
                  </el-button-group>
                </div>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="form-group col-md-9">
                  <label>{{ this.$t('event.filter.search') }}</label>
                  <el-input clearable v-model="$store.state.programrate.filter.searchTerm" :placeholder="$t('event.textbox.programrateSearch')"></el-input>
                </div>

                <div class="form-group col-md-3">
                  <label>{{ this.$t('event.table.participantNO') }}</label>
                  <el-input clearable v-model="$store.state.programrate.filter.participantNO" :placeholder="$t('ex1')"></el-input>
                </div>

                <div class="form-group col-md-4">
                  <label>{{ this.$t('evaStat') }}</label>
                  <el-select v-model="$store.state.programrate.filter.status" :placeholder="$t('event.textbox.select')" clearable>
                    <el-option v-for="item in $enums.programRateStatus" :key="item.value" :label="item.title" :value="item.value"></el-option>
                  </el-select>
                </div>

                <div class="form-group col-md-4">
                  <label>{{ this.$t('event.table.speaker') }}</label>
                  <SpeakerSearch ref="SpeakerSelect" @speakerSearchChanged="speakerSearchChanged" />
                </div>

                <div class="form-group col-md-4">
                  <label>Program</label>
                  <ProgramSearch ref="ProgramSelect" @programSearchChanged="programSearchChanged" />
                </div>
              </div>
            </div>
          </div>
        </transition>

        <div class="card">
          <div class="card-header header-elements-inline" style="padding-bottom:0px;">
            <h5 class="card-title">{{ this.$t('event.menu.reviews.title') }}</h5>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe('https://holacon.com/product-guide/')" icon="fas fa-life-ring" size="mini"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button icon="fas fa-redo-alt" size="mini" @click="$store.dispatch('getProgramRate')"></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <PageCountInfo :total="$store.state.programrate.filter.total" :skip="skip" :take="take" />

          <el-table v-loading="$store.state.programrate.loading" ref="multipleTable" :data="$store.state.programrate.items" style="width: 100%">
            <el-table-column :label="$t('event.table.participant')" width="250">
              >
              <template slot-scope="scope">
                <ParticipantMini :data="$store.state.programrate.participants.find((x) => x.id == scope.row.participantID)" />
              </template>
            </el-table-column>

            <el-table-column :label="$t('event.menu.contentsmoderation.contentmanagement.session')" width="300">
              >
              <template slot-scope="scope">
                <p>
                  {{ $store.state.programrate.programs.find((x) => x.id == scope.row.programID).title }}
                </p>

                <el-rate v-model="$store.state.programrate.programs.find((x) => x.id == scope.row.programID).avgRate" disabled />
              </template>
            </el-table-column>

            <el-table-column min-width="250" :label="$t('event.table.comment')">
              <template slot-scope="scope">
                <p style="background: whitesmoke; min-height: 50px; border-radius: 5px; padding:5px;">{{ scope.row.comment }}</p>
              </template>
            </el-table-column>

            <el-table-column align="center" :label="$t('event.table.processes')" width="150" fixed="right">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="$t('event.table.confirmAss')" placement="top" v-if="scope.row.status != 1">
                  <el-popconfirm @confirm="confirmItem(scope.$index)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="success" :title="$t('sureToApprove')">
                    <el-button slot="reference" type="success" icon="el-icon-check" circle size="mini"></el-button>
                  </el-popconfirm>
                </el-tooltip>

                <el-tooltip class="item" effect="dark" :content="$t('event.table.rejectAss')" placement="top" v-if="scope.row.status != 2">
                  <el-popconfirm @confirm="cancelItem(scope.$index)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="success" :title="$t('sureToReject')">
                    <el-button slot="reference" type="warning" icon="el-icon-close" circle size="mini"></el-button>
                  </el-popconfirm>
                </el-tooltip>

                <el-tooltip class="item" effect="dark" :content="$t('event.table.delete')" placement="top">
                  <el-popconfirm @confirm="deleteItem(scope.$index)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                    <el-button slot="reference" type="danger" icon="fas fa-trash" circle size="mini"></el-button>
                  </el-popconfirm>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="$store.state.programrate.filter.page" :page-sizes="[20, 30, 40, 50]" :page-size="100" layout="total, sizes, prev, pager, next, jumper" :total="$store.state.programrate.filter.total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import PageCountInfo from '../../components/PageCountInfo';
import $ from 'jquery';
export default {
  metaInfo: {
    title: 'Session reviews',
  },
  components: { PageCountInfo },
  name: 'ProgramRate',
  data() {
    return {
      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + 'programrate',
    };
  },
  methods: {
    exportExcel() {
      this.$confirm(this.$t('message.export'), this.$t('message.warn'), {
        confirmButtonText: this.$t('event.variables.yes'),
        cancelButtonText: this.$t('event.variables.no'),
        type: 'warning',
      }).then(() => {
        axios.post('programrate/export', { id: null }).then((res) => {
          if (res.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
          }
        });
      });
    },
    handleSizeChange(take) {
      this.$store.commit('setProgramRateTake', take);
    },
    handleCurrentChange(page) {
      $('html, body').animate({ scrollTop: 0 }, 350);
      this.$store.commit('setProgramRatePage', page);
    },
    deleteItem(index) {
      this.$store.dispatch('deleteProgramRate', { index, context: this });
    },
    confirmItem(index) {
      this.$store.dispatch('confirmProgramRate', { index, context: this });
    },
    cancelItem(index) {
      this.$store.dispatch('cancelProgramRate', { index, context: this });
    },
    speakerSearchChanged(val) {
      this.$store.state.programrate.filter.speakerID = val;
    },
    programSearchChanged(val) {
      this.$store.state.programrate.filter.programID = val;
    },
  },
  mounted() {
    this.$store.dispatch('getProgramRate');
  },
  created() {},
  computed: {
    skip() {
      return (this.$store.state.programrate.filter.page - 1) * this.$store.state.programrate.filter.take;
    },
    take() {
      return this.skip + this.$store.state.programrate.items.length;
    },
  },
  watch: {
    '$store.state.programrate.filter.searchTerm': function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch('getProgramRate');
      }, 500);
    },
    '$store.state.programrate.filter.participantNO': function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch('getProgramRate');
      }, 500);
    },
    '$store.state.programrate.filter.speakerID': function() {
      this.$store.dispatch('getProgramRate');
    },
    '$store.state.programrate.filter.programID': function() {
      this.$store.dispatch('getProgramRate');
    },
    '$store.state.programrate.filter.status': function(newVal) {
      if (newVal === '') {
        this.$store.state.programrate.filter.status = null;
      }
      this.$store.dispatch('getProgramRate');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/event/ProgramRate.vue